export default __webpack_public_path__ + "static/Proósitos-620cfa223b7442ca73c49f6f21748cd5.jpg";